import React from 'react';
import BaseModal from './BaseModal';
import NoteTagList from '../buttons/NoteTag';
import NoteTagCreate from '../forms/NoteTagCreate';
import ImageViewBox from '../../imgs/imageViewBox';
import { setSessionVar } from '../../../store/actions';
import { connect } from 'react-redux';

class NoteModal extends React.Component {
  static defaultProps = {
    categories: [],
    notes: [],
    onCloseModal: () => null,
    isOpen: false,
    title: '',
    onCreateNote: () => null,
    onRemoveNote: () => null,
  };

  constructor(props) {
    super(props);

    this.state = {
      showOk: true,
    };
  }

  onClose = () => {
    this.props.onCloseModal();
  };

  render() {
    return (
      <>
        <BaseModal
          title={this.props.title}
          open={!!this.props.isOpen}
          onClose={this.onClose}
          {...this.props}
        >
          <div className={'tag-list-wrapper'}>
            <NoteTagCreate
              onSelectCategory={() => this.setState({ showOk: false })}
              {...this.props}
              onCreateNote={(category, note) => {
                this.setState({ showOk: true });
                this.props.onCreateNote(category, note);
              }}
            />
            <NoteTagList
              notes={this.props.notes}
              onRemoveNote={this.props.onRemoveNote}
              editable={!this.props.notDeletable}
              onShowImage={(src) => {
                this.props.setImageViewBoxSrc(src);
                this.props.showImageViewBox();
              }}
            />
            {this.state.showOk && (
              <button className={'btn btn-primary mt-5'} onClick={this.onClose}>
                OK
              </button>
            )}
          </div>
        </BaseModal>
        <ImageViewBox />
      </>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  showImageViewBox: () => dispatch(setSessionVar('showImageViewBox', true)),
  setImageViewBoxSrc: (src) => dispatch(setSessionVar('imageViewBoxSrc', src)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NoteModal);
